import React from 'react';

const Login = (props) => (
  <div className="container">
    <h3>Session expired. Please login again. <a href={process.env.REACT_APP_HOST}>momkidcare</a></h3>
  </div>
)

export default Login;


// WEBPACK FOOTER //
// ./src/containers/Login.js